import React from "react";
import styles from "./MaxSizedCard.module.scss";
type Props = {
  children?: React.ReactNode;
};

export const MaxSizedCard = ({ children }: Props) => {
  return <div className={styles.card}>{children}</div>;
};
